<template>
    <button 
        type="button"
        :class="[baseClass, typeClass, {
            'btn--pending': pending || isPending,
            'btn--disabled': disabled || isDisabled,
            'btn--toggled': isToggled,
            'no-animate': noAnimate,
            [className]: className.length
        }]"
        :disabled="isDisabled"
        @click="allowAction ? handleClick($event) : null"
    >
        <slot>{{content}}</slot>
    </button>
</template>

<script>
export default {
    mixins: [],
    props: {
        // isDisabled is deprecated use "disabled"
        isDisabled: {
            type: Boolean,
            default: false
        },
        disabled: Boolean,

        // isPending is deprecated, use "pending"
        isPending: {
            type: Boolean,
            default: false
        },
        pending: Boolean,
        isToggled: Boolean,
        isMicro: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            required: true
        },
        content: {
            type: String,
            default: ''
        },
        event: {
            type: Object,
            default: () => {}
        },
        className: {
            type: String,
            default: ''
        },
    },
    data() { 
        return {
            noAnimate: false
        };
    },
    computed: {
        allowAction(){
            return (!this.pending && !this.isPending) && (!this.disabled && !this.isDisabled); 
        },
        baseClass(){
            return this.isMicro ? 'btn-micro' : 'btn';
        },
        typeClass(){
            return `${this.baseClass}-${this.type}`;
        }
    },
    watch: {
        id() {
            this.noAnimate = true;
        }
    },
    updated() {
        const vm = this;

        // restore button transition after update
        window.requestAnimationFrame(function() {
            vm.noAnimate = false;
        });
    }, 
    methods: {
        handleClick(event) {
            this.$emit('click', event);
        }
    }
};
</script>